import { Tooltip } from '@mui/material'

/**
 * Wraps children in MUI Tooltip only when title is non-empty.
 * Avoids a11y/console noise from empty tooltips and satisfies the
 * disabled-button + span wrapper pattern when needed.
 */
export function ConditionalTooltip({ title, children, disableInteractive = true, ...rest }) {
  const label = typeof title === 'string' ? title.trim() : title
  if (!label) return children
  return (
    <Tooltip title={label} disableInteractive={disableInteractive} {...rest}>
      {children}
    </Tooltip>
  )
}
